import React from 'react';
import PropTypes from 'prop-types';
import { FiCheckCircle, FiCircle } from 'react-icons/fi';
import { formatDateTime } from '../../utils/formatters';
import './ApplicationTimeline.css';

// What is done, what is next, and everything that has happened, in plain language.
const ApplicationTimeline = ({ timeline, showSteps = true }) => {
  if (!timeline) return null;
  const { next_step: nextStep, steps = [], events = [] } = timeline;

  return (
    <div className="app-timeline">
      {nextStep && (
        <div className="app-timeline__next" role="status">
          <strong>What happens next</strong>
          <p>{nextStep}</p>
        </div>
      )}

      {showSteps && (
        <ol className="app-timeline__steps" aria-label="Your checklist">
          {steps.map((step) => (
            <li key={step.key} className={step.done ? 'is-done' : ''}>
              {step.done ? <FiCheckCircle aria-hidden="true" /> : <FiCircle aria-hidden="true" />}
              <span>{step.label}</span>
              <span className="sr-only">{step.done ? ' (done)' : ' (still to do)'}</span>
            </li>
          ))}
        </ol>
      )}

      <h3 className="app-timeline__title">History</h3>
      {events.length === 0 ? (
        <p className="app-timeline__empty">Nothing has happened yet.</p>
      ) : (
        <ul className="app-timeline__events">
          {[...events].reverse().map((e, i) => (
            <li key={`${e.at}-${i}`}>
              <span className="app-timeline__time">{formatDateTime(e.at)}</span>
              <span className="app-timeline__label">
                {e.label}
                {e.detail ? <em> · {e.detail}</em> : null}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

ApplicationTimeline.propTypes = {
  timeline: PropTypes.shape({
    next_step: PropTypes.string,
    steps: PropTypes.array,
    events: PropTypes.array
  }),
  showSteps: PropTypes.bool
};

export default ApplicationTimeline;
